export default function isForeverYoung() {
  const href = window.location.href;
  return (href || '').toLowerCase().indexOf('forever-young') !== -1;
}
